import { MARD_291 } from './palette';
import type { YxpdDocument } from './projectFile';
import type { PatternWatermark } from '../types';

export function watermarkFromDocument(id: string, name: string, document: YxpdDocument, x = 2, y = 2, scale = 1, locked = false): PatternWatermark {
  const colorIndices = new Map(MARD_291.map((color, index) => [color.code, index]));
  return {
    id,
    name,
    x,
    y,
    scale: Math.max(0.25, Math.min(4, Number(scale) || 1)),
    locked,
    width: Number(document.project.width),
    height: Number(document.project.height),
    cells: document.beads.map((bead) => ({
      col: Number(bead[0]) - 1,
      row: Number(bead[1]) - 1,
      colorIndex: colorIndices.get(String(bead[2])) ?? 0
    }))
  };
}

export function watermarkCells(watermark: PatternWatermark) {
  const scale = Math.max(0.25, Math.min(4, Number(watermark.scale) || 1));
  return watermark.cells.map((cell) => ({
    col: watermark.x + cell.col * scale,
    row: watermark.y + cell.row * scale,
    size: scale,
    colorIndex: cell.colorIndex
  }));
}
